import {Checkbox, CheckboxProps} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import React from 'react'

const useInlineCheckboxStyles = makeStyles({
  root: {
    padding: 0,
    borderRadius: 0,
    color: '#093e54',
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  }
})

interface InlineCheckboxType extends CheckboxProps {
  props?: any
  'data-test-id'?: string
}
const InlineCheckbox: React.FC<InlineCheckboxType> = (props) => {
  const classes = useInlineCheckboxStyles()
  const {'data-test-id': dataTestId} = props
  const inputProps: any = dataTestId ? {'data-test-id': dataTestId + '-value'} : {}

  return (
    // Prepare for cells where we have a click handler on the whole row. We have
    // to make sure to not execute the callback there.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span onClick={(event) => event.stopPropagation()}>
      <Checkbox
        classes={classes}
        disableRipple
        color="default"
        inputProps={inputProps}
        {...props}
      />
    </span>
  )
}

export {InlineCheckbox}
